<template lang="pug">
  div(v-if="plans.length")
    b-row.mb-3
      b-col(md="6")
        b-card.no-shadow
          b-badge.text-sm.mb-3(variant="soft-secondary", pill) Gratis
          h3 Konverza Free
          p.text-help Tu comercio conversacional gratis y sin registrar tu tarjeta.
          b-row.align-items-center.mb-3(no-gutters)
            b-col(cols="auto")
              h4.mb-0.mr-1 $
            b-col(cols="auto")
              h2.mb-0 {{ $formatMoney(0) }}
                span.ml-1.text-secondary.uppercase.text-sm MXN
          b-row(no-gutters)
            b-col
              b-list-group.list-group-flush
                b-list-group-item(v-for="(feature, index) in features", :key="index")
                  b-row.align-items-center
                    b-col
                      span {{ feature }}
                    b-col(cols="auto")
                      check-circle-icon.text-success.icon-sm
                b-list-group-item
                  b-row.align-items-center
                    b-col
                      span Soporte personalizado
                    b-col(cols="auto")
                      x-circle-icon.text-danger.icon-sm
                b-list-group-item
                  b-row.align-items-center
                    b-col
                      span Conexión con Whatsapp
                    b-col(cols="auto")
                      x-circle-icon.text-danger.icon-sm
          b-button.mt-4(:variant="$route.name == 'select plan' ? 'secondary' : 'light'", block, @click="freeSelected") {{ $route.name == 'select plan' ? 'Continuar' : 'Incluído' }}
      b-col(md="6", v-for="(plan, plan_index) in sortedPlans", :key="plan_index")
        b-card.no-shadow
          b-badge.text-sm.mb-3(variant="soft-success", pill, v-if="plan.is_offer") Promoción
          h3 {{ plan.name }}
          p.text-help {{ plan.description }}
          b-row.align-items-center.mb-3(no-gutters)
            b-col(cols="auto")
              h4.mb-0.mr-1 $
            b-col(cols="auto")
              h2.mb-0 {{ $formatMoney(plan.price, 0) }}
                span.ml-1.text-secondary.uppercase.text-sm MXN
          b-row(no-gutters, v-if="plan.features")
            b-col
              b-list-group.list-group-flush
                b-list-group-item
                  b-row.align-items-center
                    b-col
                      span Plan de {{ translateDays(plan.active_days) }}
                    b-col(cols="auto")
                      check-circle-icon.text-success.icon-sm
                b-list-group-item(v-for="(feature, index) in plan.features.split('|')", :key="index")
                  b-row.align-items-center
                    b-col
                      span {{ feature }}
                    b-col(cols="auto")
                      check-circle-icon.text-success.icon-sm
          b-button.mt-4(variant="soft-primary", block, @click="getURL(plan.plan_id)") Seleccionar
    b-modal(v-model="payment_modal", :hide-footer="true", @hide="setPaymentUrl('about:blank')", :hide-header-close="paymentResultReceived", :no-close-on-esc="paymentResultReceived", no-close-on-backdrop)
      template(slot="modal-title")
        .d-flex.align-items-center
          lock-icon.icon-md.mr-2.mb-1(:class="secure_connection ? 'text-success' : 'text-secondary'")
          span Conexión segura
      .d-flex.justify-content-center(style="margin:-1rem;")
        iframe(frameborder="0", width="100%", style="max-width:498px;height:645px;", id="payment_iframe")
      .mt-4.text-secondary.text-justify Deseo utilizar mi tarjeta para esta compra y todas mis compras futuras en Konverza. Artificial Nerds tratará estos pagos como pagos preaprobados, según en las condiciones de uso de Artificial Nerds. Entiendo que si tengo saldo en mi cuenta, este se utilizará para realizar mi pago, y que si no es posible realizar el cargo a mi tarjeta, Artificial Nerds hará el cargo a mi forma de pago de respaldo. Si alguna de mis formas de pago no acepta pagos en mensualidades, el cargo se podrá realizar en un sola exhibición. Puedo cambiar mi forma de pago preferida para este comercio o cancelar esta autorización en cualquier momento en el Perfil de mi cuenta de Konverza
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const planController = createNamespacedHelpers('plan')

export default {
  data () {
    return {
      payment_modal: false,
      secure_connection: false,
      paymentResultReceived: false,
      features: [
        'Sube hasta 10 productos',
        'Comisión por venta de 8% + iva',
        'Conexión con Instagram Shop y Facebook Shop',
        'Aplicación móvil'
      ]
    }
  },
  computed: {
    ...planController.mapState({
      plans: state => state.plans
    }),
    sortedPlans () {
      return this.plans.sort((a, b) => parseFloat(a.price) - parseFloat(b.price))
        .sort((a, b) => {
          if (a.is_offer && b.is_offer) {
            return 0
          } else if (a.is_offer) {
            return -1
          } else if (b.is_offer) {
            return 1
          } else {
            return 0
          }
        })
    }
  },
  methods: {
    ...mapActions(['account/get', 'plan/all', 'plan_payment/generateURL']),
    translateDays (days) {
      if (days == 1) {
        return '1 día'
      } else if (days > 1 && days < 30) {
        return days + ' días'
      } else if (days >= 30) {
        let months = Math.floor(days / 30)
        if (months == 1) return months + ' mes'
        else return months + ' meses'
      }
    },
    getPlans () {
      this['plan/all']({
        params: {
          group: "Konverza"
        },
        callback: res => {
          if (res.error) {
          self.$message.error(res.error)
          }
        }
      })
    },
    getURL (plan_id) {
      let self = this

      this.showLoadingScreen()

      this['plan_payment/generateURL']({
        plan_id: plan_id,
        account_id: self.$route.params.account_id,
        billed_months: 1,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.payment_modal = true
            console.log(res)
            self.$nextTick(() => {
              self.setPaymentUrl(res.resource.cadena_pago)
            })
          }
        }
      })
    },
    setPaymentUrl (url) {
      document.getElementById('payment_iframe').src = url
    },
    freeSelected () {
      if (this.$route.name == 'select plan') {
        this.$router.push({ name: 'First Steps', params: { account_id: this.$route.params.account_id } })
      } else {
        this.$message.success('Tu cuenta de Konverza incluye todas funcionalidades Free')
      }
    }
  },
  mounted () {
    this.getPlans()

    window.addEventListener('message', message => {
      if (message.data == 'paymentmodal:resultReceived') {
        this.paymentResultReceived = true
      }

      if (message.data == 'paymentmodal:close') {
        // this.payment_modal = false
        window.location.reload()
      }
    })
  },
  watch: {
    payment_modal (value) {
      if (value) {
        setTimeout(() => {
          this.secure_connection = true
        }, 1300);
      } else {
        this.secure_connection = false
      }
    }
  },
}
</script>

<style lang="css" scoped>
</style>
